<template>
  <v-card elevation="0" class="">
    <v-card-text>
      <v-row class="py-4">
        <v-col cols="3">
          <h2>{{ $t("ration.rationSummary") }}</h2>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="[suggestedRations]"
        :items-per-page="10"
        hide-default-footer
      >
        <template v-slot:progress>
          <v-progress-linear
            color="primary"
            :height="8"
            indeterminate
          ></v-progress-linear>
        </template>
        <template v-slot:item.noOfAnimals=""> 1 </template>
        <template v-slot:item.nutritionValue="">
          <div class="d-flex mt-3">
            <v-text-field
              outlined
              dense
              style="width: 5em"
              v-model="nutritionValue"
              type="number"
              :suffix="'%'"
            ></v-text-field>
            <v-btn color="green white--text" class="ml-2" height="40px"
              >Update</v-btn
            >
          </div>
        </template>
      </v-data-table>

      <v-card
        :class="{
          custom_border: selectedCard.includes(
            'expiry' + suggestedRations.animalId
          ),
        }"
        class="my-2"
        elevation="0"
        @click="
          toggleCard(
            'expiry' + suggestedRations.animalId,
            suggestedRations,
            'expiry'
          )
        "
        v-if="
          suggestedRations?.expiredSoonIngredients?.length &&
          rationPriority == 'expire_soon'
        "
      >
        <v-card-text>
          <v-row>
            <v-col cols="6" class="d-flex align-center">
              <v-icon
                class="pr-2"
                :class="{
                  'green--text': selectedCard.includes(
                    'expiry' + suggestedRations.animalId
                  ),
                }"
                >mdi-record-circle</v-icon
              >

              <h3>
                {{ $t("ration.rationSuggestion") }} -
                {{ $t("ration.expireSoon") }}
              </h3>
            </v-col>
            <!-- <v-col cols="6 text-end">
              <v-btn
                color="green"
                class="white--text"
                @click="generateRation(suggestedRations, 'expiry')"
                >Generate</v-btn
              >
            </v-col> -->
          </v-row>

          <!-- SUGGESTED RATION - EXPIRE SOON -->

          <v-data-table
            class="mt-4"
            :headers="suggestionRationHeaders"
            :items="[suggestedRations.expiredSoonIngredients]"
            :items-per-page="10"
            :options.sync="options"
            hide-default-footer
            hide-default-header
          >
            <template v-slot:header="{ props }">
              <thead class="v-data-table-header">
                <tr>
                  <th
                    v-for="header in props.headers"
                    :key="header.value"
                    :style="{ 'min-width': header.width }"
                    class="text-left"
                  >
                    {{ header.text }}
                    <v-tooltip
                      top
                      color="black"
                      max-width="350"
                      v-if="
                        header.text != '' &&
                        header.text != 'Ingredient Name' &&
                        header.text != 'Price KG' &&
                        header.text != 'Expire Date'
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          style="margin-top: -4px; margin-left: -2px"
                          size="15"
                          v-bind="attrs"
                          v-on="on"
                          >mdi-help-circle-outline</v-icon
                        >
                      </template>
                      <span> Tooltip Data</span>
                    </v-tooltip>
                    <v-icon
                      v-if="
                        header.text != '' &&
                        header.text != 'Ingredient Name' &&
                        header.sortable
                      "
                      class="mb-1 ml-1"
                      :class="{
                        'black--text':
                          options.sortBy[0] &&
                          options.sortBy[0] == header.value,
                      }"
                      @click="sortRecords(header)"
                      >mdi-unfold-more-horizontal</v-icon
                    >
                  </th>
                </tr>
              </thead>
            </template>
            <template v-if="items.length > 0" v-slot:body="{ items }">
              <tbody
                :style="
                  isExpandedTableFirst
                    ? 'display:table-row-group'
                    : 'display:none'
                "
              >
                <tr
                  v-for="(
                    item, index
                  ) in suggestedRations.expiresSoonIngredients"
                  :key="index"
                  :style="{ backgroundColor: randomColor(item.id) }"
                >
                  <template>
                    <td class="text-decoration-underline">
                      {{ item.ingredientDetails.name }}
                    </td>
                    <td>
                      {{
                        item?.ingredientDetails?.nutritionalValues?.dryMatter
                      }}
                    </td>
                    <td>
                      {{ item?.ingredientDetails?.nutritionalValues?.tdn }}
                    </td>
                    <td>
                      {{
                        item?.ingredientDetails?.nutritionalValues?.crudeProtein
                      }}
                    </td>
                    <td>
                      {{ item?.ingredientDetails?.nutritionalValues?.calcium }}
                    </td>
                    <td>
                      {{
                        item?.ingredientDetails?.nutritionalValues?.phosphorus
                      }}
                    </td>
                    <td>
                      {{ item?.ingredientDetails?.price }}
                    </td>
                    <td>
                      <v-btn color="green" outlined rounded>{{
                        item.expireDate
                      }}</v-btn>
                    </td>
                  </template>
                </tr>
              </tbody>
            </template>
            <template v-slot:foot="">
              <tr class="py-3 footer">
                <template>
                  <th>Total Ration</th>
                  <th>
                    {{
                      suggestedRations?.expireSoonIngredientTotal?.dryMatter ??
                      0
                    }}
                    <v-icon small class="green--text">mdi-arrow-up</v-icon>
                  </th>
                  <th>
                    {{ suggestedRations?.expireSoonIngredientTotal?.tdn ?? 0 }}
                    <v-icon small class="green--text">mdi-arrow-up</v-icon>
                  </th>
                  <th>
                    {{
                      suggestedRations.expireSoonIngredientTotal.crudeProtein ??
                      0
                    }}
                    <v-icon small class="green--text">mdi-arrow-up</v-icon>
                  </th>
                  <th>
                    {{
                      suggestedRations.expireSoonIngredientTotal.calcium ?? 0
                    }}
                    <v-icon small class="green--text">mdi-arrow-up</v-icon>
                  </th>
                  <th>
                    {{
                      suggestedRations.expireSoonIngredientTotal.phosphorus ?? 0
                    }}
                    <v-icon small class="green--text">mdi-arrow-up</v-icon>
                  </th>
                  <th>7.73%</th>
                  <th></th>
                </template>
              </tr>
            </template>
          </v-data-table>

          <div class="d-flex justify-center mt-5">
            <v-btn
              color="primary"
              outlined
              @click="expandToggleTableFirst"
              class="px-2"
            >
              {{
                isExpandedTableFirst
                  ? "Hide Ration Details"
                  : "Show Ration Details"
              }}
              <v-icon
                >mdi-chevron-{{ isExpandedTableFirst ? "down" : "up" }}</v-icon
              >
            </v-btn>
          </div>
        </v-card-text>
      </v-card>

      <v-card
        :class="{
          custom_border: selectedCard.includes(
            'lowCost' + suggestedRations.animalId
          ),
        }"
        class="my-2"
        elevation="0"
        @click="
          toggleCard(
            'lowCost' + suggestedRations.animalId,
            suggestedRations,
            'low-cost'
          )
        "
        v-if="
          suggestedRations?.lowCostSuggestion?.length &&
          rationPriority == 'lowest_price'
        "
      >
        <v-card-text>
          <v-row>
            <v-col cols="6" class="d-flex align-center">
              <v-icon
                class="pr-2"
                :class="{
                  'green--text': selectedCard.includes(
                    'lowCost' + suggestedRations.animalId
                  ),
                }"
                >mdi-record-circle</v-icon
              >

              <h3>
                {{ $t("ration.rationSuggestion") }} -
                {{ $t("ration.lowestPrice") }}
              </h3>
            </v-col>
            <!-- <v-col cols="6 text-end">
              <v-btn
                color="green"
                class="white--text"
                @click="generateRation(suggestedRations, 'low-cost')"
                >Generate</v-btn
              >
            </v-col> -->
          </v-row>
          <!-- SUGGESTED RATION - {{ $t("ration.lowestPrice") }} -->

          <v-data-table
            class="mt-4"
            :headers="suggestionRationHeaders"
            :items="[suggestedRations.lowCostSuggestion]"
            :items-per-page="10"
            :options.sync="options"
            hide-default-footer
            hide-default-header
          >
            <template v-slot:header="{ props }">
              <thead class="v-data-table-header">
                <tr>
                  <th
                    v-for="header in props.headers"
                    :key="header.value"
                    :style="{ 'min-width': header.width }"
                    class="text-left"
                  >
                    {{ header.text }}
                    <v-tooltip
                      top
                      color="black"
                      max-width="350"
                      v-if="
                        header.text != '' &&
                        header.text != 'Ingredient Name' &&
                        header.text != 'Price KG' &&
                        header.text != 'Expire Date'
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          style="margin-top: -4px; margin-left: -2px"
                          size="15"
                          v-bind="attrs"
                          v-on="on"
                          >mdi-help-circle-outline</v-icon
                        >
                      </template>
                      <span> Tooltip Data</span>
                    </v-tooltip>
                    <v-icon
                      v-if="
                        header.text != '' &&
                        header.text != 'Ingredient Name' &&
                        header.sortable
                      "
                      class="mb-1 ml-1"
                      :class="{
                        'black--text':
                          options.sortBy[0] &&
                          options.sortBy[0] == header.value,
                      }"
                      @click="sortRecords(header)"
                      >mdi-unfold-more-horizontal</v-icon
                    >
                  </th>
                </tr>
              </thead>
            </template>
            <template v-if="items.length > 0" v-slot:body="{ items }">
              <tbody
                :style="
                  isExpandedTableSecond
                    ? 'display:table-row-group'
                    : 'display:none'
                "
              >
                <tr
                  v-for="(item, index) in suggestedRations.lowCostSuggestion"
                  :key="index"
                  :style="{ backgroundColor: randomColor(item.id) }"
                >
                  <template>
                    <td class="text-decoration-underline">
                      {{ item.ingredientDetails.name }}
                    </td>
                    <td>
                      {{
                        item?.ingredientDetails?.nutritionalValues?.dryMatter ??
                        0
                      }}
                    </td>
                    <td>
                      {{ item?.ingredientDetails?.nutritionalValues?.tdn ?? 0 }}
                    </td>
                    <td>
                      {{
                        item?.ingredientDetails?.nutritionalValues
                          ?.crudeProtein ?? 0
                      }}
                    </td>
                    <td>
                      {{
                        item?.ingredientDetails?.nutritionalValues?.calcium ?? 0
                      }}
                    </td>
                    <td>
                      {{
                        item?.ingredientDetails?.nutritionalValues
                          ?.phosphorus ?? 0
                      }}
                    </td>
                    <td>
                      {{ item?.ingredientDetails?.price }}
                    </td>
                    <td>
                      <v-btn color="green" outlined rounded>{{
                        item.expireDate
                      }}</v-btn>
                    </td>
                  </template>
                </tr>
              </tbody>
            </template>
            <template v-slot:foot="">
              <tr class="py-3 footer">
                <template>
                  <th>Total Ration</th>
                  <th>
                    {{ suggestedRations.lowCostIngredientTotal.dryMatter }}
                    <v-icon small class="green--text">mdi-arrow-up</v-icon>
                  </th>
                  <th>
                    {{ suggestedRations.lowCostIngredientTotal.tdn }}
                    <v-icon small class="green--text">mdi-arrow-up</v-icon>
                  </th>
                  <th>
                    {{ suggestedRations.lowCostIngredientTotal.crudeProtein }}
                    <v-icon small class="green--text">mdi-arrow-up</v-icon>
                  </th>
                  <th>
                    {{ suggestedRations.lowCostIngredientTotal.calcium }}
                    <v-icon small class="green--text">mdi-arrow-up</v-icon>
                  </th>
                  <th>
                    {{ suggestedRations.lowCostIngredientTotal.phosphorus }}
                    <v-icon small class="green--text">mdi-arrow-up</v-icon>
                  </th>
                  <th>7.73%</th>
                  <th></th>
                </template>
              </tr>
            </template>
          </v-data-table>

          <div class="d-flex justify-center mt-5">
            <v-btn
              color="primary"
              outlined
              @click="expandToggleTableSecond"
              class="px-2"
            >
              {{
                isExpandedTableSecond
                  ? "Hide Ration Details"
                  : "Show Ration Details"
              }}
              <v-icon
                >mdi-chevron-{{ isExpandedTableSecond ? "down" : "up" }}</v-icon
              >
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import { generateIngredientSingleAnimal } from "@/graphql/FeedMgmt.gql";
import loadingMixin from "@/mixins/LoadingMixin";
export default {
  data() {
    return {
      isExpandedTableFirst: false,
      isExpandedTableSecond: false,
      nutritionValue: 90,
      selectedCard: [],
      menu: false,
      itemsPerPageSlider: 0,
      itemsPerPageOptions: [5, 10, 25, 50],
      to: "",
      from: "",
      totalPages: "",
      search: "",
      selected: [],
      totalAnimals: 1,
      selectedItem: false,
      loading: false,
      length: 0,
      pageCount: 1,
      tableOptions: {},
      loadingText: "Loading... Please wait",
      tab: null,
      headers: [
        {
          text: "No. of Animals",
          value: "noOfAnimals",
          class: "black--text",
        },
        {
          text: "No. of Rations",
          value: "noOfRations",
          class: "black--text",
        },
        {
          text: "Body Weight Range",
          value: "bodyWeightRange",
          class: "black--text",
        },
        {
          text: "Ration Quantity / Animal",
          value: "rationQuantityPerAnimal",
          class: "black--text",
        },
        {
          text: "Ration Cost/Animal",
          value: "totalRationCost",
          class: "black--text",
        },
        {
          text: "Total Cost of Ration",
          value: "rationCostPerAnimal",
          class: "black--text",
        },
        {
          text: "Total Ration Quantity",
          value: "totalRationQuantity",
          class: "black--text",
        },
        {
          text: "Nutrition Value/Animal",
          value: "nutritionalValuePerAnimal",
          class: "black--text",
        },
      ],
      items: [
        {
          id: 1,
          noOfAnimals: 12,
          noOfRations: 23,
          bodyWeight: "400 to 500kg",
          rationQty: "18.5 kg",
          rationCost: "$3.50",
          totalCost: "$30.5",
          totalRationQty: "$30.5",
          nutritionValue: "",
        },
      ],

      suggestionRationHeaders: [
        {
          text: "Ingredient Name",
          value: "ingredientName",
          class: "black--text",
          sortable: false,
        },
        {
          text: "DM (kg)",
          value: "DM",
          class: "black--text",
          sortable: false,
        },
        {
          text: "TDN (kg)",
          value: "TDN",
          class: "black--text",
          sortable: false,
        },
        {
          text: "CP (g)",
          value: "CP",
          class: "black--text",
          sortable: false,
        },
        {
          text: "(Ca)",
          value: "CA",
          class: "black--text",
          sortable: false,
        },
        {
          text: "(p)",
          value: "P",
          class: "black--text",
          sortable: false,
        },
        {
          text: "Price KG",
          value: "priceKG",
          class: "black--text",
          sortable: false,
        },
        {
          text: "Expire Date",
          value: "expireDate",
          class: "black--text",
          sortable: false,
        },
      ],
      suggestionRationItems: [
        {
          id: 0,
          ingredientName: "Barley Grain",
          DM: "5.5 kg",
          TDN: "1.67% ",
          CP: "2.45% ",
          CA: "12% Kg",
          P: "10% kg",
          priceKg: "$0.45",
          expireDate: "10-01-2023",
        },
        {
          id: 0,
          ingredientName: "Barley Grain",
          DM: "5.5 kg",
          TDN: "1.67% ",
          CP: "2.45% ",
          CA: "12% Kg",
          P: "10% kg",
          priceKg: "$0.45",
          expireDate: "10-01-2023",
        },
        {
          id: 1,
          ingredientName: "Barley Grain",
          DM: "5.5 kg",
          TDN: "1.67% ",
          CP: "2.45% ",
          CA: "12% Kg",
          P: "10% kg",
          priceKg: "$0.45",
          expireDate: "10-01-2023",
        },
        {
          id: 2,
          ingredientName: "Barley Grain",
          DM: "5.5 kg",
          TDN: "1.67% ",
          CP: "2.45% ",
          CA: "12% Kg",
          P: "10% kg",
          priceKg: "$0.45",
          expireDate: "10-01-2023",
        },
      ],
    };
  },
  methods: {
    randomColor(index) {
      let colors = ["#FEF0F0", "#FFFFFF", "#FFE6C2"];
      return colors[index];
    },
    expandToggleTableFirst() {
      this.isExpandedTableFirst = !this.isExpandedTableFirst;
    },
    expandToggleTableSecond() {
      this.isExpandedTableSecond = !this.isExpandedTableSecond;
    },

    toggleCard(index, ration, type) {
      // if (this.selectedCard.includes(index)) {
      //   // REMOVE FROM THE SELECTED CARD
      //   this.selectedCard = this.selectedCard.filter((item) => item !== index);
      // } else {
      //   this.selectedCard.push(index);
      // }
      //       debugger;
      //       // return;
      const data = {
        percentageNutrientRequirement: 100,
        suggestionType: type,
        rationId: +ration.rationId,
        animalId: +ration.animalId,
      };
      //       // console.log(data);
      if (this.selectedCard.includes(index)) {
        this.$emit("generateAllData", "remove", data);
        // REMOVE FROM THE SELECTED CARD
        this.selectedCard = this.selectedCard.filter(item => item !== index);
      } else {
        this.$emit("generateAllData", "add", data);
        this.selectedCard.push(index);
      }
    },
    async generateRation(item, type) {
      console.log(item);
      this.startLoading();
      await this.$apollo
        .mutate({
          mutation: generateIngredientSingleAnimal,
          variables: {
            generateIngredientSingleAnimalInput: {
              rationId: +item.rationId,
              animalId: +item.animalId,
              percentageNutrientRequirement: 100, //need to chagne
              suggestionType: type,
            },
          },
        })
        .then(res => {
          this.stopLoading();
          console.log(
            "generate ingredient",
            res?.data?.generateIngredientSingleAnimal
          );
          if (res?.data) {
            this.$emit("rationData", [
              {
                rationId: res?.data?.generateIngredientSingleAnimal.rationId,
                rationName:
                  res?.data?.generateIngredientSingleAnimal.rationName,
                updateMode: false,
              },
            ]);
          }

          this.closeModal(true);
        })
        .catch(error => {
          this.$notify({
            title: "Error!",
            text: error?.graphQLErrors[0].message,
            type: "error",
          });
          this.stopLoading();
        });
    },
  },
  props: {
    suggestedRations: {
      type: Object,
      required: true,
    },
    rationPriority: {
      type: String,
      required: true,
    },
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
::v-deep .footer {
  background: #e0f9f1 !important;
  line-height: 3rem;
}

::v-deep .footer th {
  text-align: left;
  padding-left: 1rem;
}

::v-deep .custom_border {
  border: 1px solid #00bd73;
}

::v-deep .v-data-table > .v-data-table__wrapper > table {
  border-spacing: 0 8px;
}
</style>
